import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import {
  StyledSubtab,
  StyledSubtabs,
} from '../../../../components/StyledSubtabs';
import BenchmarkOrgs from './BenchmarkOrgs';
import BenchmarkBuildings from './BenchmarkBuildings';
import CreateBenchmarks from './CreateBenchmarks';
import QueryBenchmarks from './QueryBenchmarks';
import CountyLookup from './CountyLookup';


const ORGANIZATIONS = 'Organizations';
const BUILDINGS = 'Buildings'
const BENCHMARKS1 = 'Create Benchmarks'
const BENCHMARKS2 = 'Query Benchmarks'
const COUNTY = 'County Lookup'
const SUBTABS = [ORGANIZATIONS, BUILDINGS, BENCHMARKS1, BENCHMARKS2, COUNTY];


export default function Benchmarking() {
  const [tab, setTab] = useState(ORGANIZATIONS);

  const handleSelect = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Grid
      container
      justifyContent='center'
      spacing={1}
      sx={{ maxWidth: '100%', mt: 1 }}>
      <Grid
        size={{ xs: 12 }}
        sx={{ display: 'flex', justifyContent: 'center', mx: 1 }}>
        <StyledSubtabs
          variant='fullWidth'
          sx={{ maxWidth: 600, width: '100%' }}
          value={tab}
          onChange={handleSelect}>
          {SUBTABS.map((tab) => (
            <StyledSubtab key={tab} label={tab} value={tab} />
          ))}
        </StyledSubtabs>
      </Grid>
      {tab === ORGANIZATIONS && <BenchmarkOrgs />}
      {tab === BUILDINGS && <BenchmarkBuildings />}
      {tab === BENCHMARKS1 && <CreateBenchmarks />}
      {tab === BENCHMARKS2 && <QueryBenchmarks />}
      {tab === COUNTY && <CountyLookup />}
    </Grid>
  );
}